import {APP_INITIALIZER, Component, OnInit, ViewEncapsulation} from '@angular/core';
import {NavigationEnd, Router, RouterOutlet} from "@angular/router";
import {AuthService} from "./_services/auth.service";
import {SettingsProvider} from "./_services/config.service";
import {UrlService} from "./_services/url.service";
import {OAuthModule, OAuthService} from "angular-oauth2-oidc";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [
    RouterOutlet
  ],
  styleUrls: ['./app.component.css'],
  encapsulation: ViewEncapsulation.None
})

export class AppComponent implements OnInit {
  title = 'app';
  // @ts-ignore
  previousUrl: string = null;
  // @ts-ignore
  currentUrl: string = null;

  public constructor(
    private router: Router,
    private authService: AuthService,
    private settingsProvider: SettingsProvider,
    private urlService: UrlService
  ) {
    console.log('AppComponent init', authService);
  }

  async ngOnInit() {
    this.configure();

    this.router.events.subscribe((evt) => {
      if (!(evt instanceof NavigationEnd)) {
        return;
      }

      this.previousUrl = this.currentUrl;
      this.currentUrl = evt.url;
      this.urlService.setPreviousUrl(this.previousUrl);

      window.scrollTo(0, 0);
    });
  }

  public login(): void {
    this.authService.login();
  }

  public logout(): void {
    this.authService.logOut();
    this.router.navigate(['/']);
  }

  private async configure() {
    let requestedUrl = sessionStorage.getItem('requestedUrl');
    if (!requestedUrl && location.pathname + location.search !== '/' && !location.search.startsWith('?code=')) {
      sessionStorage.setItem('requestedUrl', location.pathname + location.search);
    }
  }
}
